import { useMutation } from "@tanstack/react-query";
import { getDevicesOfProperty } from "@/shared/requests/property";

export function useListDevicesOfProperty() {
  return useMutation(getDevicesOfProperty);
}
